export default "__VITE_ASSET__0cf1b6ff__"